import { Map, fromJS } from 'immutable'
import { IReduxAction } from 'common/interfaces.d'
import { get } from 'lodash'
import {
  RECEIVE_USER_ACCESS_TOKEN,
  IReceiveUserAccessTokenAction
} from 'sideEffects/UserToken/actionCreators'
import { RESTORE_STORE } from 'common/actionCreators/accessToken'

export interface IAccessTokenStore extends Map<string, any> {
  isLoaded: boolean
  expirationTime: number
  accessToken: string
  uuid: string
}

export const STORE_NAME: string = 'accessToken'

const initialStore = Map({
  isLoaded: false,
  expirationTime: -1,
  accessToken: '',
  uuid: ''
}) as IAccessTokenStore

function restore(_store: IAccessTokenStore, action: any): IAccessTokenStore {
  const { data } = action

  return fromJS(data) as IAccessTokenStore
}

function receiveUserAccessToken(
  _store: IAccessTokenStore,
  action: IReceiveUserAccessTokenAction
): IAccessTokenStore {
  return Map({
    isLoaded: true,
    expirationTime: get(action, 'data.expirationTime', -1),
    accessToken: get(action, 'data.accessToken', ''),
    uuid: get(action, 'data.uuid', '')
  }) as IAccessTokenStore
}

export default function accessToken(
  store: IAccessTokenStore = initialStore,
  action?: IReduxAction
): IAccessTokenStore {
  if (typeof action === 'object') {
    switch (action.type) {
      case RECEIVE_USER_ACCESS_TOKEN:
        return receiveUserAccessToken(
          store,
          action as IReceiveUserAccessTokenAction
        )

      case RESTORE_STORE:
        return restore(store, action)
    }
  }

  return store
}
